module.exports = __webpack_public_path__ + "assets/media/lunch.f9bbc2c7.mp3";